import { OpinButtonsFooterModule } from './buttons-footer/buttons-footer.module';
import { OpinSharingCardListModule } from './sharing-card-list/sharing-card-list.module';

const COMPONENTS = [OpinSharingCardListModule, OpinButtonsFooterModule];

export default COMPONENTS;
